module.exports = __webpack_public_path__ + "img/fireteam_sunrise.937b1fb6.webp";